import { useEffect, useRef } from 'react'
import { useSelector } from 'react-redux'
import { useAnalytics } from '~/app/features/Gallery/hooks/useAnalytics'
import { getIsDirectQuickView } from '~/app/store/debug'
import { galleryImpressionsTrackingSelector } from '~/app/store/analytics'
import { AnalyticsNames } from 'shared/constants'
import { getRawExperiments } from '~/app/store/experimentation'
import { instrumenter } from '~/app/utils/instrumentation'
import { getGalleryIdSelector, getGalleryNameSelector, getLocaleSelector, getProductKey } from '~/app/store/config'
import { totalEntityCountSelector } from '~/app/store/paging'
import { getExperienceType, getQuickViewId } from '~/app/store/debug'
import { EXPERIENCE_TYPE } from 'shared/constants'

export const useInitTracking = () => {
  const analytics = useAnalytics()
  const isDirectQuickView = useSelector(getIsDirectQuickView)
  const impression = useSelector(
    (state: State.GlobalState) => galleryImpressionsTrackingSelector(state, analytics, AnalyticsNames.DesignTile),
    () => true,
  )
  const rawExperiments = useSelector(getRawExperiments)
  const locale = useSelector(getLocaleSelector)
  const resultCount = useSelector(totalEntityCountSelector)
  const galleryName = useSelector(getGalleryNameSelector)
  const galleryId = useSelector(getGalleryIdSelector)
  const productKey = useSelector(getProductKey)
  const designId = useSelector(getQuickViewId, () => true)
  const experienceType = useSelector(getExperienceType)

  const didTrackRef = useRef(false)

  useEffect(() => {
    if (didTrackRef.current) {
      return
    }

    if (!isDirectQuickView) {
      analytics.trackImpression(impression)
    }
    analytics.trackNavigation()

    // NewRelic page view
    const featureFlags = rawExperiments ? JSON.parse(rawExperiments).map((exp: Gallery.ABExperimentation.GalleryExperiment) => exp.FeatureFlag) : ''
    instrumenter.setPageView('gallery', {
      locale,
      entityCount: resultCount,
      galleryName,
      galleryId,
      productKey,
      featureFlag: featureFlags.toString(),
      quickViewId: designId?.toString(),
      experienceType: experienceType || EXPERIENCE_TYPE.GALLERY,
    })

    didTrackRef.current = true
    // Intentional empty deps: run once on mount only (not on state changes).
    // Guarded by didTrackRef to avoid React StrictMode double-invoke.
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [])
}
